import { t } from "../i18n";
import { REGIONS } from "../regions";
import { fuel, regionKey, setRegion } from "../state";
import type { Fuel } from "../types";

const FUELS: Fuel[] = ["95", "98", "diesel"];

// Keys in regions.ts that are translation keys (go through t()) rather
// than literal labels.
const TRANSLATED_REGION_LABELS = new Set(["region_all"]);

export function FilterBar() {
  return (
    <div class="filter-bar">
      <label class="filter-field">
        <span class="filter-label">{t("fuel_label")}</span>
        <select
          value={fuel.value}
          onChange={(e) => {
            fuel.value = (e.currentTarget as HTMLSelectElement).value as Fuel;
          }}
        >
          {FUELS.map((f) => (
            <option key={f} value={f}>
              {t(`fuel_${f}` as `fuel_${Fuel}`)}
            </option>
          ))}
        </select>
      </label>

      <label class="filter-field">
        <span class="filter-label">{t("region_label")}</span>
        <select
          value={regionKey.value}
          onChange={(e) => {
            // setRegion() persists the choice to the URL hash so reloads
            // and share-links keep the filter stable (mirrors setLang).
            setRegion((e.currentTarget as HTMLSelectElement).value);
          }}
        >
          {REGIONS.map((r) => (
            <option key={r.key} value={r.key}>
              {TRANSLATED_REGION_LABELS.has(r.label)
                ? t(r.label as "region_all")
                : r.label}
            </option>
          ))}
        </select>
      </label>
    </div>
  );
}
